// extracted by mini-css-extract-plugin
export default {"delete-report-popup":"DeleteReportPopup_delete-report-popup__MqJgW"};